import React from 'react';
import { useTranslation } from 'react-i18next';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

const icons = ['📁', '🎥', '✉️', '🔗', '📅', '💳'];
const statuses: ('live' | 'planned')[] = ['live', 'live', 'live', 'live', 'live', 'live'];

const IntegrationsSection: React.FC = () => {
  const { t } = useTranslation();
  const headerRef = useScrollAnimation<HTMLDivElement>();
  const gridRef = useScrollAnimation<HTMLDivElement>(0.05);

  const items = t('integrations.items', { returnObjects: true }) as { name: string; description: string }[];

  return (
    <section id="integrations" className="hp-integrations" aria-labelledby="integrations-title">
      <div className="hp-integrations-inner">
        <div ref={headerRef} className="hp-section-header hp-animate">
          <span className="hp-section-label">{t('integrations.sectionLabel')}</span>
          <h2 id="integrations-title">{t('integrations.title')}</h2>
          <p>{t('integrations.subtitle')}</p>
        </div>

        <div ref={gridRef} className="hp-integrations-grid hp-animate hp-animate-stagger">
          {items.map((item, i) => (
            <div
              key={item.name}
              className="hp-integration-card hp-animate-child"
              style={{ transitionDelay: `${i * 0.08}s` }}
            >
              <div className="hp-integration-card-icon" aria-hidden="true">{icons[i]}</div>
              <h3>{item.name}</h3>
              <p>{item.description}</p>
              <span className={`hp-integration-badge hp-integration-badge--${statuses[i] === 'live' ? 'live' : 'planned'}`}>
                {statuses[i] === 'live' ? t('integrations.statusLive') : t('integrations.statusPlanned')}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IntegrationsSection;
